import { graphql } from "../generated/gql";

export const UpdateEvaluation = graphql(`
  mutation UpdateEvaluation($input: UpdateEvaluationInput!) {
    updateEvaluation(input: $input) {
      __typename

      ... on GenericException {
        ...BaseException
      }

      ... on ResourceNotFoundException {
        ...BaseException
      }

      ... on UserInputException {
        ...UserInputException
      }

      ... on Evaluation {
        ID
        feedback
        revieweeUserId
        reviewerUserId
        categories {
          ID
          questions {
            ... on BinaryEvaluationQuestion {
              ID
              feedback
              binaryAnswer
              score {
                scorePoints
                totalPoints
                normalizedScore
              }
            }
            ... on RatingEvaluationQuestion {
              ID
              feedback
              ratingAnswer
              score {
                scorePoints
                totalPoints
                normalizedScore
              }
            }
          }
        }
        score {
          scorePoints
          totalPoints
          normalizedScore
        }
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`);
